<template>
  <div class="candidate-search">
    <h1 class="centered-text">Søk etter kandidater</h1>
    <div class="search-flex">
      <div class="sidebar">
        <input type="text" class="search-field" />
        <br />
        <button class="remove-criterias-button" @click="removeCriteria">
          Nullstill kriterier
        </button>
        <div
          class="category"
          v-for="(searchOption, name) of this.$store.state.searchOptions"
          v-bind:key="name"
        >
          <h3>{{ name }}</h3>

          <label
            class="filter-item"
            v-for="(task, index) in searchOption"
            v-bind:key="index"
          >
            <input class="criteria" type="checkbox" />
            <span>{{ task }}</span>
          </label>
        </div>
      </div>

      <div class="search-results">
        <!-- <p v-if="candidates.length > 0" class="student-count">
          Antall elever:
          <span> {{ candidates.length }} </span>
        </p>
        <p v-else class="student-count">Laster inn...</p> -->
        <div class="search-results-header">
          <!-- <h2>Resultater</h2> -->
          <select id="selectorator" @change="sortByList()">
            <option value="age, asc">Alder stigende</option>
            <option value="age, desc">Alder synkende</option>
            <option value="name, asc" selected>Alfabetisk stigende</option>
            <option value="name, desc">Alfabetisk synkende</option>
            <option value="city, asc">Bosted stigende</option>
            <option value="city, desc">Bosted synkende</option>
          </select>
        </div>

        <SearchResultCard
          class="student-list-item"
          v-for="candidate of $store.state.allCandidates"
          v-bind:key="candidate.id"
          :candidate="candidate"
        />
      </div>
    </div>
  </div>
</template>

<script>
// import axios from "axios";
import { mapActions } from "vuex";

import SearchResultCard from "@/components/SearchResultCard";

export default {
  name: "CandidateSearch",
  components: {
    SearchResultCard,
  },
  data() {
    return {
      // candidates: [],
    };
  },
  methods: {
    ...mapActions(["getCandidates"]),
    // ...mapActions(["getCandidates", "getToken"]),

    sortByList() {
      var selectBox = document.getElementById("selectorator");
      var selectedValue = selectBox.options[selectBox.selectedIndex].value;
      console.log(selectedValue);
      // this.candidates.sort()
    },
    removeCriteria() {
      var inp = document.getElementsByClassName("criteria");
      for (let i = 0; i < inp.length; i++) {
        inp[i].checked = false;
      }
    },
  },

  async mounted() {
    //   await this.getToken();
    //   var xxx = this.$store.getters.axiosConfig;
    //   console.log(xxx);
    //   await axios
    //     .get(
    //       `${this.$store.state.baseApiUrl}/Candidate`,
    //       xxx
    //     )
    //     .then((response) => {
    //       this.allStudents = response.data;
    //     });

    await this.getCandidates().then((candidates) => {
      // console.log("her får vi: ", candidates);
      this.candidates = candidates;
      // console.log("Kandidater hentet");
    });

    // this.getCandidates();
  },
};
</script>

<style lang="scss" scoped>
.candidate-search {
  width: 90%;
}
.category {
  padding-bottom: 1rem;
  border-top: 2px solid #333333 !important;
  border-radius: 0;
}
h3 {
  margin-top: 1.4em;
  margin-bottom: 0;
  font-size: 1em;
}

// .centered-text {
//   text-align: center;
// }

.remove-criterias-button {
  margin: 10px 0 1rem;
  background-color: var(--white-color);
  color: var(--secondary-color);
  letter-spacing: 0.0625em;
  border: 2px solid transparent;
}
.remove-criterias-button:hover {
  border: 2px solid var(--secondary-color);
  border-radius: 5rem;
  background-color: transparent;
  border-color: var(--secondary-color);
  color: var(--secondary-color);
}
.search-flex {
  display: flex;
  flex-direction: row;
  margin-top: 40px;
}

.sidebar {
  display: flex;
  flex-direction: column;
  width: 200px;
}

.search-field {
  padding: 0.5em;
  font-size: 1.1em;
}

.filter-item {
  display: block;
  padding: 6px 0;
  cursor: pointer;

  &:hover {
    color: var(--primary-color);
  }

  span {
    margin-left: 5px;
  }
}

.student-count {
  & > * {
    color: var(--primary-color);
    font-size: 2rem;
    font-weight: 900;
  }
}

.search-results {
  flex-grow: 1;
  margin-left: 2em;
  display: flex;
  flex-direction: column;
}

.student-list-item {
  &:nth-child(even) {
    background-color: var(--secondary-background-color);
  }
}

.search-results-header {
  border-bottom: 2px solid #d3d3d3;
  padding-bottom: 15px;
  margin-bottom: 1em;

  & > * {
    float: right;
  }

  & > h2 {
    margin: 0;
    float: left;
  }
}
</style>